import { Routes } from '@angular/router';
import { guestGuard } from '../core/guards/guest.guard';
import { homeGuard } from '../core/guards/home.guard';

export const publicRoutes: Routes = [
  {
    path: '',
    canActivate: [homeGuard],
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'registro',
    canActivate: [guestGuard],
    loadComponent: () => import('./auth/registro/registro.component').then(m => m.RegistroComponent)
  },
  {
    path: 'registro-sucesso',
    loadComponent: () => import('./auth/registro-sucesso/registro-sucesso.component').then(m => m.RegistroSucessoComponent)
  },
  {
    path: 'recuperar-senha',
    loadComponent: () => import('./auth/recuperar-senha/recuperar-senha.component').then(m => m.RecuperarSenhaComponent)
  },
  {
    path: 'farmacias',
    loadComponent: () => import('./farmacias/lista/lista.component').then(m => m.ListaComponent)
  },
  {
    path: 'farmacias/:id',
    loadComponent: () => import('./farmacias/detalhes/detalhes.component').then(m => m.DetalhesComponent)
  },
  {
    path: 'planos',
    loadComponent: () => import('./planos/planos.component').then(m => m.PlanosComponent)
  },
  {
    path: 'para-voce',
    loadComponent: () => import('./landing-pages/para-voce.component').then(m => m.ParaVoceComponent)
  },
  {
    path: 'para-farmacia',
    loadComponent: () => import('./landing-pages/para-farmacia.component').then(m => m.ParaFarmaciaComponent)
  },
  {
    path: 'para-clinica',
    loadComponent: () => import('./landing-pages/para-clinica.component').then(m => m.ParaClinicaComponent)
  },
  {
    path: 'para-deposito',
    loadComponent: () => import('./landing-pages/para-deposito.component').then(m => m.ParaDepositoComponent)
  },
  {
    path: 'para-profissionais',
    loadComponent: () => import('./landing-pages/para-profissionais.component').then(m => m.ParaProfissionaisComponent)
  },
  {
    path: 'suporte',
    children: [
      {
        path: 'ajuda',
        loadComponent: () => import('./suporte/central-ajuda/central-ajuda.component').then(m => m.CentralAjudaComponent)
      },
      {
        path: 'faq',
        loadComponent: () => import('./suporte/faq/faq.component').then(m => m.FaqComponent)
      },
      {
        path: 'contato',
        loadComponent: () => import('./suporte/contato/contato.component').then(m => m.ContatoComponent)
      },
      {
        path: 'privacidade',
        loadComponent: () => import('./suporte/privacidade/privacidade.component').then(m => m.PrivacidadeComponent)
      },
      {
        path: 'termos',
        loadComponent: () => import('./suporte/termos/termos.component').then(m => m.TermosComponent)
      },
      {
        path: '',
        redirectTo: 'ajuda',
        pathMatch: 'full'
      }
    ]
  }
];
